import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { NotificationMessageLevel, NotificationService } from '@lib/core';
import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { MatIconButton } from '@angular/material/button';
import { RequiredUtilsModule } from '@lib/util';
import { TranslateModule } from '@ngx-translate/core';
import { MatTooltip } from '@angular/material/tooltip';
import { FrameworkAgreement } from './SupplierFrameworkAgreement';
import { FrameworkAgreementService } from './demand-supplier-framework-agreement.service';
import { SupplierFrameworkAgreementDataService } from './demand-supplier-framework-agreement-data.service';

@Component({
    selector: 'demand-supplier-framework-agreement',
    imports: [MatIconButton, RequiredUtilsModule, TranslateModule, MatTooltip],
    templateUrl: './demand-supplier-framework-agreement.html',
})
export class DemandSupplierFrameworkAgreementComponent implements OnInit {
    private readonly notificationService = inject(NotificationService);
    private readonly frameworkAgreementService = inject(FrameworkAgreementService);
    private readonly supplierFrameworkAgreementDataService = inject(SupplierFrameworkAgreementDataService);

    @Input() public frameworkAgreement?: FrameworkAgreement;
    @Input({ required: true }) public supplierCompanyId!: string;
    @Input({ required: true }) public demandId!: string;
    @Input() public editable = false;

    @Output() deleted = new EventEmitter<void>();
    @Output() updated = new EventEmitter<FrameworkAgreement>();

    public frameworkAgreementOptions?: FrameworkAgreement[];

    ngOnInit(): void {
        this.getOptions();
    }

    public openFrameworkAgreementSelection(): void {
        this.frameworkAgreementService
            .selectFrameworkAgreement(this.supplierCompanyId, this.editable, this.frameworkAgreementOptions!)
            .subscribe((result: FrameworkAgreement | void) => {
                if (result) {
                    this.updateFrameworkAgreement(result);
                }
            });
    }

    public deleteFrameworkAgreement(newFrameworkAgreement: FrameworkAgreement, $event: Event): void {
        $event.stopPropagation();
        this.supplierFrameworkAgreementDataService
            .deleteSupplierFrameworkAgreement(this.demandId, this.supplierCompanyId, newFrameworkAgreement)
            .subscribe(() => {
                const message = marker('Lieferantenrahmenvertrag erfolgreich gelöscht');
                this.notificationService.showNotification(message, NotificationMessageLevel.SUCCESS);
                this.frameworkAgreement = undefined;
                this.deleted.emit();
            });
    }

    public updateFrameworkAgreement(newFrameworkAgreement: FrameworkAgreement): void {
        this.supplierFrameworkAgreementDataService
            .updateSupplierFrameworkAgreement(this.demandId, this.supplierCompanyId, newFrameworkAgreement)
            .subscribe(() => {
                const message = marker('Lieferantenrahmenvertrag erfolgreich hinzugefügt');
                this.notificationService.showNotification(message, NotificationMessageLevel.SUCCESS);
                this.frameworkAgreement = newFrameworkAgreement;
                this.updated.emit(newFrameworkAgreement);
            });
    }

    private getOptions(): void {
        if (!this.frameworkAgreementOptions) {
            this.supplierFrameworkAgreementDataService
                .getAllSupplierFrameworkAgreement(this.supplierCompanyId)
                .subscribe((frameworkAgreement: FrameworkAgreement[]) => {
                    this.frameworkAgreementOptions = frameworkAgreement;
                });
        }
    }
}
